import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  display: flex;

  width: 100%;
  height: 100%;

  align-items: center;
  justify-content: center;

  font-family: "Mulish";

  background-color: #ddd;
`;

interface ItypeFile {
  haveFiles: boolean;
}

export const Content = styled.div<ItypeFile>`
  display: flex;
  flex-direction: column;

  height: ${(props) => (props.haveFiles ? "auto" : "68vh")};
  width: 45vw;

  background-color: white;

  max-height: 90vh;

  overflow: auto;

  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);

  border-radius: 10px;

  padding: 2rem;

  align-items: center;

  transition: all 0.2s ease-in-out;

  .header {
    text-align: center;

    h3 {
      font-size: 1.3rem;

      color: #456e98;
    }

    .description {
      margin-top: 12px;
      padding: 0 30px;

      text-align: center;

      color: #a9a5bd;
    }
  }

  input {
    border: 2px solid #456e98;

    width: 50%;
    height: 40px;

    margin-top: 30px;

    padding: 2px;

    border-top: 0;
    border-left: 0;
    border-right: 0;

    transition: all 0.2s ease-in-out;

    text-align: center;

    color: #456e98;

    ::placeholder {
      color: #b9bccd;
    }

    :focus {
      border-top: 0;
      border-left: 0;
      border-right: 0;
    }
  }

  input.error {
    border-bottom: 2px solid red;
  }

  .error-message {
    font-size: 12px;
    color: red;
  }

  .confirm button {
    margin-top: 20px;
    padding: 10px 50px;

    border-radius: 5px;

    background: none;

    transition: all 0.1s ease-in-out;
  }

  .enabled button {
    cursor: pointer;

    color: #3751ff;

    border: 1px solid #3751ff;

    :hover {
      background: #3751ff;

      color: white;
    }
  }

  .disabled button {
    color: #ddd;

    border: 1px solid #ddd;
  }
`;

interface IDropContainerTypes {
  active: boolean;
}

export const DropContainer = styled.div<IDropContainerTypes>`
  width: 100%;

  padding-bottom: 10px;

  margin-top: 30px;

  border: 2.8px dashed ${(props) => (props.active ? "#3751ff" : "#ddd")};
  border-radius: 3px;

  cursor: pointer;

  transition: all 0.2s ease;
`;

export const UploadMessageContainer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
`;

const messageColors = {
  default: "#CACDDF",
  error: "red",
  success: "green",
};

interface ITypeMessageColor {
  type?: "default" | "error" | "success";
}

export const UploadMessage = styled.p<ITypeMessageColor>`
  display: flex;
  flex-direction: column;

  color: ${(props) => messageColors[props.type || "default"]};

  justify-content: center;
  align-items: center;

  line-height: 30px;

  text-align: center;

  span {
    background-color: #3751ff;
    box-shadow: 0 6px 10px rgba(55, 81, 255, 0.4);

    padding: 5px 15px;

    border-radius: 5px;

    color: white;
  }
`;

export const FilesContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 300px;

  padding-right: 5px;

  margin-top: 1rem;

  overflow: auto;

  ::-webkit-scrollbar {
    width: 6px;
  }
`;

const textFadeIn = keyframes`
  0% {
    opacity: 0;

    transform: translateY(15px)
  }

  100% {
    opacity: 1;
  }
`;

const fileAnimation = keyframes`
  0% {
    transform: translateX(-15px);
  }

  100% {
    opacity: 1;
  }
`;

interface IFileTypes {
  progress: number;
}

export const File = styled.div<IFileTypes>`
  display: flex;
  flex-direction: column;

  align-items: center;

  border: 1px solid #ddd;
  border-radius: 10px;

  background: linear-gradient(
    to left,
    rgba(5, 0, 255, 5%) ${(props) => `${props.progress}%`},
    white 0%
  );

  gap: 10px;

  opacity: 0;

  padding: 10px 30px;
  margin-top: 1rem;

  animation: ${fileAnimation} 0.3s ease forwards;

  .up {
    display: flex;

    justify-content: space-between;
    align-items: center;

    width: 100%;

    .status {
      font-family: Roboto;

      font-size: 1.2rem;
      font-weight: bold;

      color: #456e98;
    }

    .info {
      display: flex;

      align-items: center;

      gap: 20px;

      padding: 5px 0;

      p {
        color: #cacddf;
      }
    }

    .buttons-wrapper {
      display: flex;

      gap: 20px;

      button {
        height: 35px;
        width: 35px;

        border-radius: 50%;
        border: 0;

        cursor: pointer;
      }

      .pause {
        background-color: #f0f3f6;

        color: #a3b7cb;
      }

      .cancel {
        background-color: #ffe7ea;

        color: #fd3355;

        transition: all 0.2s;

        :hover {
          background-color: #fd3355;

          color: #ffe7ea;
        }
      }
    }
  }

  .progressBar-wrapper {
    width: 100%;
  }

  img {
    height: 40px;
  }

  p {
    max-width: 230px;

    color: #6870a8;

    text-overflow: ellipsis;
    overflow: hidden;

    animation: ${textFadeIn} ease-in-out 0.4s;

    white-space: nowrap;
  }

  .completed {
    display: flex;

    width: 100%;
    height: 100%;

    justify-content: space-between;
    align-items: center;

    p {
      font-family: Roboto;
      font-weight: bold;
      font-size: 1.1rem;
    }
  }
`;
